var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-dialog",
    {
      ref: "dialog",
      attrs: {
        color: "success",
        icon: "mdi-plus",
        "store-modal": "",
        title: _vm.generateMessage("requests.actions.add_request")
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function() {
            return [
              _c(
                "div",
                { staticClass: "d-flex justify-end" },
                [
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: {
                        small: "",
                        color: "success",
                        loading: _vm.isLoading,
                        disabled: !_vm.body.property_id || !_vm.validRequest
                      },
                      on: { click: _vm.validate }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.validate")
                          ) +
                          "\n      "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      staticClass: "mx-2",
                      attrs: { small: "" },
                      on: { click: _vm.cancel }
                    },
                    [
                      _vm._v(
                        "\n        " +
                          _vm._s(
                            _vm.generateMessage("requests.actions.cancel")
                          ) +
                          "\n      "
                      )
                    ]
                  )
                ],
                1
              )
            ]
          },
          proxy: true
        }
      ])
    },
    [
      _c(
        "div",
        { staticStyle: { height: "700px", "max-height": "60vh" } },
        [
          _c(
            "v-stepper",
            {
              attrs: { "non-linear": "" },
              model: {
                value: _vm.step,
                callback: function($$v) {
                  _vm.step = $$v
                },
                expression: "step"
              }
            },
            [
              _c(
                "v-stepper-header",
                [
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        complete: !!_vm.body.property_id,
                        editable: "",
                        step: "1",
                        color: "success"
                      }
                    },
                    [_vm._v("\n          Choix installation\n        ")]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    {
                      attrs: {
                        editable: "",
                        step: "2",
                        color: "success",
                        complete: !!_vm.validCustomer
                      }
                    },
                    [_vm._v("\n          Choix Appelant\n        ")]
                  ),
                  _vm._v(" "),
                  _c("v-divider"),
                  _vm._v(" "),
                  _c(
                    "v-stepper-step",
                    { attrs: { editable: "", step: "3", color: "success" } },
                    [
                      _vm._v(
                        "\n          Création Demande d'intervention\n        "
                      )
                    ]
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-stepper-items",
                [
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "1" } },
                    [
                      _c(
                        "div",
                        { staticClass: "d-flex align-center" },
                        [
                          _c("property-selector", {
                            staticClass: "ma-2 caption",
                            attrs: { "hide-details": "", color: "success" },
                            on: { input: _vm.setPropertyId },
                            model: {
                              value: _vm.body.property_id,
                              callback: function($$v) {
                                _vm.$set(_vm.body, "property_id", $$v)
                              },
                              expression: "body.property_id"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                small: "",
                                color: "success",
                                disabled: !_vm.body.property_id
                              },
                              on: { click: _vm.confirmProperty }
                            },
                            [_vm._v("\n              Confirmer\n            ")]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c("v-textarea", {
                        attrs: {
                          readonly: "",
                          outlined: "",
                          value:
                            _vm.body.property_id &&
                            _vm.property.reactive_instructions,
                          loading: _vm.isLoadingInstructions,
                          label: "Consigne Technicien",
                          color: "success"
                        }
                      }),
                      _vm._v(" "),
                      _c("v-textarea", {
                        attrs: {
                          readonly: "",
                          outlined: "",
                          value:
                            _vm.body.property_id &&
                            _vm.property.operator_instructions,
                          loading: _vm.isLoadingInstructions,
                          label: "Consigne Opérateur",
                          color: "success"
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "2" } },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "customerForm",
                          model: {
                            value: _vm.validCustomer,
                            callback: function($$v) {
                              _vm.validCustomer = $$v
                            },
                            expression: "validCustomer"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex align-center" },
                            [
                              _c("v-select", {
                                staticClass: "mx-2 caption",
                                attrs: {
                                  label: "Type de client*",
                                  color: "success",
                                  "item-value": "id",
                                  "item-text": "name",
                                  outlined: "",
                                  dense: "",
                                  clearable: "",
                                  items: _vm.customer_types,
                                  rules: [
                                    v => !!v || "Ce champ est obligatoire."
                                  ]
                                },
                                model: {
                                  value: _vm.body.customer_type,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "customer_type", $$v)
                                  },
                                  expression: "body.customer_type"
                                }
                              }),
                              _vm._v(" "),
                              _c(
                                "v-btn",
                                {
                                  staticClass: "mx-2",
                                  attrs: {
                                    small: "",
                                    color: "success",
                                    disabled: !_vm.validCustomer
                                  },
                                  on: { click: _vm.confirmCustomer }
                                },
                                [
                                  _vm._v(
                                    "\n                Confirmer\n              "
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                staticClass: "mx-2 caption flex-grow-0",
                                staticStyle: { "flex-basis": "180px" },
                                attrs: {
                                  label: "Civilité *",
                                  color: "success",
                                  outlined: "",
                                  dense: "",
                                  items: _vm.customer_civils,
                                  rules: [
                                    v => !!v || "Ce champ est obligatoire."
                                  ]
                                },
                                model: {
                                  value: _vm.body.customer_civil,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "customer_civil", $$v)
                                  },
                                  expression: "body.customer_civil"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mx-2 caption",
                                attrs: {
                                  label: "Nom *",
                                  color: "success",
                                  rules: [
                                    v =>
                                      v.length > 0 ||
                                      "Ce champ est obligatoire.",
                                    v =>
                                      v.length <= 40 || "Maximum 40 caratères."
                                  ],
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.body.customer_name,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "customer_name", $$v)
                                  },
                                  expression: "body.customer_name"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mx-2 caption",
                                attrs: {
                                  label: "Téléphone *",
                                  color: "success",
                                  rules: [
                                    v =>
                                      v.length > 0 ||
                                      "Ce champ est obligatoire.",
                                    v =>
                                      v.length <= 15 || "Maximum 15 caratères."
                                  ],
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.body.customer_phone,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "customer_phone", $$v)
                                  },
                                  expression: "body.customer_phone"
                                }
                              })
                            ],
                            1
                          )
                        ]
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-stepper-content",
                    { attrs: { step: "3" } },
                    [
                      _c(
                        "v-form",
                        {
                          ref: "requestForm",
                          model: {
                            value: _vm.validRequest,
                            callback: function($$v) {
                              _vm.validRequest = $$v
                            },
                            expression: "validRequest"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("v-text-field", {
                                staticClass: "mx-2 caption",
                                attrs: {
                                  label: "Date appel",
                                  type: "datetime-local",
                                  color: "success",
                                  readonly: "",
                                  outlined: ""
                                },
                                model: {
                                  value: _vm.body.signalisation_datetime,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.body,
                                      "signalisation_datetime",
                                      $$v
                                    )
                                  },
                                  expression: "body.signalisation_datetime"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mx-2 caption",
                                attrs: {
                                  label: "Date limite",
                                  type: "datetime-local",
                                  color: "success",
                                  clearable: "",
                                  outlined: "",
                                  rules: [
                                    val =>
                                      !val ||
                                      val >= this.body.signalisation_datetime ||
                                      "La date limite ne peut pas être dans le passé."
                                  ]
                                },
                                model: {
                                  value: _vm.body.limit_datetime,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "limit_datetime", $$v)
                                  },
                                  expression: "body.limit_datetime"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("v-select", {
                                staticClass: "mx-2 caption flex-grow-1",
                                staticStyle: { "flex-basis": "100px" },
                                attrs: {
                                  label: "Urgence",
                                  color: "success",
                                  outlined: "",
                                  dense: "",
                                  "item-value": "code",
                                  items: _vm.urgencies
                                },
                                model: {
                                  value: _vm.body.urgency_code,
                                  callback: function($$v) {
                                    _vm.$set(_vm.body, "urgency_code", $$v)
                                  },
                                  expression: "body.urgency_code"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                staticClass: "mx-2 caption flex-grow-1",
                                staticStyle: { "flex-basis": "100px" },
                                attrs: {
                                  label: "Référence Externe",
                                  color: "success",
                                  outlined: "",
                                  rules: [
                                    v =>
                                      v.length <= 20 || "Maximum 20 caratères."
                                  ]
                                },
                                model: {
                                  value: _vm.body.external_reference,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.body,
                                      "external_reference",
                                      $$v
                                    )
                                  },
                                  expression: "body.external_reference"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "d-flex" },
                            [
                              _c("service-autocomplete", {
                                staticClass: "ma-2 caption",
                                attrs: {
                                  placeholder: "Symptome *",
                                  idField: "code",
                                  dense: "",
                                  color: "success",
                                  "use-entities": false,
                                  "cache-items": "",
                                  "item-text": "name",
                                  "item-value": "code",
                                  "search-attributes-array": ["name"],
                                  "variable-url": _vm._f("symptomUrl")(
                                    _vm.body.property_id
                                  ),
                                  disabled: !_vm.body.property_id,
                                  rules: [
                                    v => !!v || "Ce champ est obligatoire"
                                  ]
                                },
                                on: { input: _vm.onSymptomChange },
                                model: {
                                  value: _vm.body.work_order_group_type_code,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.body,
                                      "work_order_group_type_code",
                                      $$v
                                    )
                                  },
                                  expression: "body.work_order_group_type_code"
                                }
                              }),
                              _vm._v(" "),
                              _c("service-autocomplete", {
                                staticClass: "ma-2 caption",
                                attrs: {
                                  placeholder: "Qualification *",
                                  idField: "code",
                                  dense: "",
                                  color: "success",
                                  "use-entities": false,
                                  "item-text": "name",
                                  "item-value": "code",
                                  "search-attributes-array": ["name"],
                                  "variable-url": _vm._f("qualifUrl")(
                                    _vm.body.property_id
                                  ),
                                  disabled: !_vm.body.property_id,
                                  baseAndQueryParams: _vm._f("qualifParams")(
                                    _vm.body.work_order_group_type_code
                                  ),
                                  rules: [
                                    v => !!v || "Ce champ est obligatoire"
                                  ]
                                },
                                model: {
                                  value: _vm.body.work_order_group_qualif_code,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.body,
                                      "work_order_group_qualif_code",
                                      $$v
                                    )
                                  },
                                  expression:
                                    "body.work_order_group_qualif_code"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("custom-text-area", {
                            staticClass: "mx-2",
                            attrs: {
                              color: "success",
                              maxCharacter: 3950,
                              errorTooLongMsg: "Maximun 3950 caractères.",
                              label: _vm.generateMessage(
                                "requests.actions.comment"
                              )
                            },
                            model: {
                              value: _vm.body.customer_comment,
                              callback: function($$v) {
                                _vm.$set(_vm.body, "customer_comment", $$v)
                              },
                              expression: "body.customer_comment"
                            }
                          })
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }